import { useEffect, useState } from 'react';
import { api } from '../api';
import { initials } from '../lib/kb';

/*
 * Аватар сотрудника: фотография, если она загружена, иначе инициалы.
 *
 * Список тех, у кого есть фотография, запрашивается один раз на всё
 * приложение — иначе каждая строчка ленты дёргала бы сервер впустую.
 */

// логин → версия фотографии; версия попадает в адрес, поэтому после
// замены браузер забирает новый файл, а не показывает прежний из кэша
let cache: Map<string, string> | null = null;
let pending: Promise<Map<string, string>> | null = null;
const listeners = new Set<() => void>();

function loadOwners(): Promise<Map<string, string>> {
  if (cache) return Promise.resolve(cache);
  if (!pending) {
    pending = api
      .avatarOwners()
      .then((list) => {
        cache = new Map(list.map((o) => [o.login, o.at]));
        listeners.forEach((fn) => fn());
        return cache;
      })
      .catch(() => new Map<string, string>());
  }
  return pending;
}

/** После смены фотографии список нужно перечитать. */
export function refreshAvatars() {
  cache = null;
  pending = null;
  loadOwners();
}

export function Avatar({
  login,
  name,
  size = 30,
  className = '',
}: {
  login: string;
  name: string;
  size?: number;
  className?: string;
}) {
  const [owners, setOwners] = useState<Map<string, string> | null>(cache);
  const [failed, setFailed] = useState('');

  useEffect(() => {
    const update = () => setOwners(cache ? new Map(cache) : null);
    listeners.add(update);
    loadOwners().then(update);
    return () => {
      listeners.delete(update);
    };
  }, []);

  const version = owners?.get(login);
  const style = { width: size, height: size, fontSize: Math.round(size * 0.36) };

  if (!version || failed === version) {
    return (
      <span className={`ava ${className}`} style={style}>
        {initials(name)}
      </span>
    );
  }
  return (
    <img
      className={`ava ava-img ${className}`}
      style={style}
      src={api.avatarUrl(login, version)}
      alt={name}
      onError={() => setFailed(version)}
    />
  );
}
